import Joi from '@hapi/joi'
export const vehicleListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),

}
export const VehicleSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Estate required`
    }),

    vehicleTypeID: Joi.number().invalid(0).required().label("vehicleTypeID").messages({
        "any.invalid": `Select Employee Category.`,
        "any.required": `vehicle Type required`
    }),


    vehicleRegistrationNumber: Joi.string().max(100).required().label("vehicleRegistrationNumber ").messages({
        "string.empty": `vehicleRegistration No required`,
        "string.pattern.base": `Please enter valid vehicleRegistrationNumber`,
        "string.max": `Please enter {#limit} characters.`
    }),

    capacity: Joi.number().positive().allow().required().label("capacity").messages({
        "number.empty": `Default Value`,
        "any.required": `Please Enter Default Value`
    }),
}